import { auth } from '@/firebase';
import {
  signInWithEmailAndPassword,
  signOut as fbSignOut,
  onAuthStateChanged,
  getIdTokenResult,
  sendPasswordResetEmail,
  type User,
} from 'firebase/auth';

export type UserRole = 'admin' | 'vereador' | 'instituicao' | 'gestor' | undefined;

export const signIn = (email: string, password: string) =>
  signInWithEmailAndPassword(auth, email, password);

export const signOut = () => fbSignOut(auth);

export const resetPassword = (email: string) => sendPasswordResetEmail(auth, email);

export const listenAuth = (callback: (user: User | null, role?: UserRole) => void) =>
  onAuthStateChanged(auth, async (user) => {
    if (!user) {
      callback(null, undefined);
      return;
    }
    try {
      const token = await getIdTokenResult(user);
      const role = token.claims?.role as UserRole;
      callback(user, role);
    } catch (e) {
      callback(user, undefined);
    }
  });
